import React from 'react';
import { observer } from 'mobx-react';
import { ModulesVM } from '../modules.viewmodel';
import { ModuleRow } from '../_module-row/module-row';
import { HubModuleVM } from '../hub-module.viewmodel';
import { DragDropList } from '../../../../../../../global/drag-drop-list/drag-drop-list';

type ModulesListProps = {
    vm: ModulesVM;
    canManage: boolean;
};

export type DraggableModule = {
    id: number;
    vm: HubModuleVM;
};

export const ModulesList: React.FC<ModulesListProps> = observer(({ vm, canManage }) => {
    const renderModuleRow = (moduleVM: HubModuleVM): JSX.Element => (
        <ModuleRow
            key={moduleVM.getClientId()}
            vm={moduleVM}
            onEdit={vm.openEditModuleModal}
            onToggleActive={vm.toggleModuleActive}
            onRemove={vm.removeModule}
            editingDisabled={!canManage}
        />
    );

    const activeModules = vm.activeModules;
    const draggableModules: DraggableModule[] = activeModules.map(moduleVM => ({ id: moduleVM.getClientId(), vm: moduleVM }));

    const handleReorder = (reordered: DraggableModule[]): void => {
        vm.reorderActiveModules(reordered.map(item => item.vm));
    };

    return (
        <div className='modules-section__list'>
            {canManage ? (
                <DragDropList
                    dragHandleBy='item'
                    showDropPlaceholder
                    data={draggableModules}
                    renderItem={item => renderModuleRow(item.vm)}
                    onDragEnd={handleReorder}
                />
            ) : (
                activeModules.map(renderModuleRow)
            )}
        </div>
    );
});
